import Logo from "../components/Logo";

const LegalLayout = ({ title, updated, children }) => (
    <div className="min-h-screen bg-white">
        <header className="border-b border-slate-100">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
                <a href="/" aria-label="Back to Sevano home">
                    <Logo />
                </a>
                <a href="/" className="text-xs font-semibold text-slate-500 hover:text-[#0B5CF5] transition-colors">
                    ← Back to home
                </a>
            </div>
        </header>
        <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
            <h1 className="font-display font-medium text-3xl sm:text-4xl text-slate-900 tracking-tight">{title}</h1>
            <p className="mt-2 text-xs text-slate-400">Last updated: {updated}</p>
            <div className="mt-8 space-y-6 text-sm sm:text-base text-slate-600 leading-relaxed">{children}</div>
        </main>
    </div>
);

export const Privacy = () => (
    <LegalLayout title="Privacy Policy" updated="July 2026">
        <p>
            Sevano ("we", "our") is building an on-demand household-help service for Agartala, Tripura. This
            page explains what the early-access form collects and how it is used.
        </p>
        <h2 className="text-lg font-bold text-slate-900">What we collect</h2>
        <p>
            When you join the early access list we store your name, mobile number, locality and (optionally)
            your email address, along with the time you signed up. We also keep a simple, anonymous count of
            page visits to understand interest. We do not use third-party advertising trackers.
        </p>
        <h2 className="text-lg font-bold text-slate-900">How we use it</h2>
        <p>
            Your details are used only to contact you about the Sevano launch in your locality — via SMS,
            call, WhatsApp or email. Locality interest helps us decide where to launch first. We never sell
            or share your personal details with third parties for their own marketing.
        </p>
        <h2 className="text-lg font-bold text-slate-900">Your choices</h2>
        <p>
            You can ask us to correct or remove your details at any time by writing to hello@sevano.in.
            Removal requests are honoured promptly.
        </p>
        <h2 className="text-lg font-bold text-slate-900">Data security</h2>
        <p>
            Lead data is stored securely with access limited to the Sevano operations team. We keep it only
            as long as needed for the launch and early pilot.
        </p>
    </LegalLayout>
);

export const Terms = () => (
    <LegalLayout title="Terms &amp; Conditions" updated="July 2026">
        <p>
            Welcome to Sevano. These terms govern your use of this website and the early-access list. Sevano
            is currently in a pre-launch phase in Agartala, Tripura.
        </p>
        <h2 className="text-lg font-bold text-slate-900">Pre-launch status</h2>
        <p>
            Sevano is not yet accepting bookings. Features described on this site — including verified
            helpers, on-demand booking and arrival-time targets — are planned capabilities, not services
            available today. Joining the early-access list expresses interest only; it does not create a
            booking, contract or guarantee of service availability or timing.
        </p>
        <h2 className="text-lg font-bold text-slate-900">Honest communication</h2>
        <p>
            Any arrival-time figures shown on this site are ambitions we are working toward. Actual arrival
            times, when the service launches, will depend on zone coverage and helper availability, and will
            always be shown honestly before you confirm anything.
        </p>
        <h2 className="text-lg font-bold text-slate-900">Acceptable use</h2>
        <p>
            Please provide accurate details in the early-access form and do not attempt to misuse or disrupt
            the website.
        </p>
        <h2 className="text-lg font-bold text-slate-900">Contact</h2>
        <p>Questions about these terms: hello@sevano.in — Agartala, Tripura 799001.</p>
    </LegalLayout>
);
